import styled from "styled-components";

import { darken } from "polished";
import { Input } from "@rocketseat/unform";
import "../../index.scss";

export const Container = styled.div`
	width: 50%;
	height: 100%;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
	background: #23242f;

	@media only screen and (max-device-width: 900px) {
		width: 100%;
		background: #13141b;
	}
`;

export const Content = styled.section`
  width: 27rem;
  height: 100%;
  background: #23242F
  z-index: 1000;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: 'MetropolisRegular';

  @media only screen and (max-device-width: 900px) {
    width: 100%;
    background: #13141B;
    position: relative;
    max-width: 23rem;
    height: 90%;
    justify-content: flex-start;
  }

  @media only screen and (max-device-width: 380px) {
    width: 85%;
  }

  form {
    opacity: 1;
    width: 100%;
    max-width: 27rem;
  }
`;

export const Title = styled.span`
	font-size: 24px;
	color: #ffffff;
	margin-bottom: 20px;
	font-family: var(--font-family-metropolis-semi-bold);
	width: 100%;
`;

export const FormGroupInput = styled.div`
	position: relative;
	padding-top: 13px;

	input {
		font-size: 16px;
		color: #ffffff;
		padding: 16px 50px 16px 16px;
		height: 56px;
		width: 100%;
		outline: none;
		z-index: 1;
		background-color: transparent;
		border-radius: 8px;
	}

	.container-password {
		display: flex;
		align-items: center;
	}

	label {
		font-family: var(--font-family-metropolis-semi-bold);
		margin-bottom: 4px;
	}
`;

export const PasswordEye = styled.div`
	cursor: pointer;
	color: ${(props) => (props.error ? "#D30D48" : "#CACED4")};
	position: absolute;
	right: 16px;
	z-index: 1;
`;

export const MessageError = styled.span`
	color: #d30d48;
	font-family: var(--font-family-metropolis-semi-bold);
	font-size: 12px;
`;

export const FormGroupLine = styled.div`
	color: #6f6f70;
	display: flex;
	justify-content: space-between;
	align-items: baseline;

	button {
		background: transparent;
		border: 0;
		color: #04a4b0;
		text-decoration: none;
		font-size: 12px;

		&:hover {
			color: #025e65;
			text-decoration: underline;
		}
	}
`;

export const ContainerRequirements = styled.div`
	height: 8rem;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: space-evenly;
	margin-top: 4px;

	@media only screen and (max-device-width: 380px) {
		height: 6rem;
		margin-top: 10px;
	}
`;

export const Group = styled.div`
	span {
		margin-left: 5px;
		font-family: "MetropolisRegular";
		font-size: 12px;
		color: #ffff;
		margin-bottom: 4px;
	}
`;

export const InputText = styled(Input).withConfig({
	shouldForwardProp: (props) => props !== "error",
})`
	font-family: "MetropolisRegular";
	font-size: 16px;
	border: solid 2px ${(props) => (!props.error.value ? "#353546" : "#D30D48")} !important;

	&:focus {
		border: solid 2px ${(props) => (!props.error.value ? "#01E59B" : "#D30D48")} !important;
	}
`;

export const Label = styled.label`
	font-size: 12px;
	color: #ffffff;
`;

export const SubmitButtom = styled.button`
	width: 100%;
	margin-top: 40px;
	background-color: #01e59b;
	border-radius: 8px;
	align-self: center;
	color: #13141b;
	padding: 5px;
	border: 0px;
	font-size: 16px;
	height: 40px;
	font-family: var(--font-family-metropolis-semi-bold);
	outline: none !important;

	&:hover {
		background: ${darken(0.03, "#01E59B")};
	}

	&:disabled {
		opacity: 0.24;
	}
`;
